import { useParams } from "react-router-dom";
import ProfileForm from "../../components/Profile/ProfileForm";
import { useModal } from "../../hooks/use-modal.jsx";
import { Profile } from "../../models/profile";
import { useCandidatProfiles } from "../../hooks/use-profiles-indiv";

export default function CandidatProfileEditPage() {
  let { profileId } = useParams();
  profileId = parseInt(profileId);

  const [Modal, closeModal] = useModal(true);

  const { profilesById, updateProfile } = useCandidatProfiles({
    withById: true,
  });

  return (
    <ProfileForm
      profile={profilesById[profileId]}
      onSubmit={async (data) => {
        await updateProfile(profileId, Profile.create(data));
        closeModal();
      }}
      modal={Modal}
      isCandidat
    />
  );
}
